// core
import {Injectable} from '@angular/core';

// services
import {CustomHttp} from '../../core/http-custom/http-custom.service';

// models
import {User} from '../models/user.model';
import {MyProfileChangePassword} from '../../my-profile-change-password/model/my-profile-change-password.model';
import {Observable} from 'rxjs';
import {UntypedFormGroup} from '@angular/forms';
import {AppConstants} from "../../utils/constants";
import {HttpParams} from "@angular/common/http";
import {DataPrivacyNotice} from "../models/data-privacy-notice.model";

@Injectable()
export class UserRegistrationServiceService {
  private baseUrl: string;

  constructor(private http: CustomHttp) {
    this.baseUrl = '/apps/umng/api/usermng';
  }

  /**
   * @description get languages options
   * @return {any}
   */
  public getLanguages() {
    return this.http.get(`${this.baseUrl}/languages`);
  }

  /**
   * @description get countries options
   * @return {any}
   */
  public getCountries() {
    return this.http.get(`${this.baseUrl}/countries`);
  }

  /**
   * @description get titles options
   * @return {any}
   */
  public getSalutations() {
    return this.http.get(`${this.baseUrl}/titles`);
  }

  /**
   * @description get target groups options
   * @return {any}
   */
  public getTargetGroups() : Observable<any> {
    return this.http.get(`${this.baseUrl}/targetGroups`);
  }

  public saveUser(user: UntypedFormGroup) : Observable<User> {
    return this.http.post(`/apps/umng/user/register`, user);
  }

  public forgetPassword(email, language) {
    let params = new HttpParams();
    params = params.append("email", email);
    return this.http.get(AppConstants.forgotPasswordEndpoint, null, params);
  }

  public changePassword(passwordDetails) {
    return this.http.post(`/apps/umng/verify_email_setup_password`, passwordDetails);
  }

  public myProfileChangePassword(changePassword: MyProfileChangePassword) {
    return this.http.patch(AppConstants.updatePasswordEndpoint, changePassword);
  }

  public resetPassword(passwordDetails) {
    return this.http.patch(AppConstants.resetPasswordEndpoint, passwordDetails);
  }

  public getDataPrivacyNotice(language: string): Observable<DataPrivacyNotice> {
    const params = new HttpParams().append("lang", language);
    return this.http.get(AppConstants.dataPrivacyNoticeEndpoint, null, params);
  }

}
